module.exports = __webpack_public_path__ + "static/img/logo07.3bad036.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo07.png
// module id = fCu1
// module chunks = 1